import { MLPVersion } from '@nextgen-web-framework/all';
import { Formik, Form } from 'formik';
import PasswordWithConfirm from './MLPv1/password-with-confirm/PasswordWithConfirm';
import PasswordWithoutConfirm from './MLPv1/password-without-confirm/PasswordWithoutConfirm';
import CurrentPassword from './MLPv2/current-password/CurrentPassword';
import { AmwayPasswordInputProps, ComponentType } from './types/propTypes';

const AmwayPasswordInput = (props: AmwayPasswordInputProps) => {
  const {
    mlpVersion = MLPVersion.ONE,
    component,
    onPasswordChange,
    onPasswordMeetsMinimumChange,
    isPasswordUsePrev,
  } = props;

  const initialValues = {
    createPassword: '',
    confirmPassword: '',
    currentPassword: '',
  };

  const handleSubmit = () => {
    // Do nothing
  };

  const { NEXT_PUBLIC_IDENTITY_ALLOW_PASSWORD_STRENGTH_METER: allowPasswordStrengthMeter } = ConfigService.getConfigs();
  const verifyForm = { initialValues, onSubmit: handleSubmit };

  const fetchComponent = () => {
    switch (mlpVersion) {
      case MLPVersion.ONE:
        if (!allowPasswordStrengthMeter && component === ComponentType.WITH_CONFIRM) {
          return <PasswordWithConfirm {...props} />;
        } else {
          return (
            <PasswordWithoutConfirm
              {...props}
              onPasswordChange={onPasswordChange}
              onPasswordMeetsMinimumChange={onPasswordMeetsMinimumChange}
              isPasswordUsePrev={isPasswordUsePrev}
            />
          );
        }
      case MLPVersion.TWO:
        return <CurrentPassword {...props} />;
      default:
        return <PasswordWithConfirm {...props} />;
    }
  };

  return (
    <>
      {component === ComponentType.WITH_CONFIRM ? (
        <Formik {...verifyForm}>
          <Form>{fetchComponent()}</Form>
        </Formik>
      ) : (
        fetchComponent()
      )}
    </>
  );
};

export default AmwayPasswordInput;
